import { createColumnHelper } from '@tanstack/react-table';
import { SelectFieldProps } from '@mews-commander/form';
import { lt, FormSelectField } from '@mews/framework';
import { ColumnFilterType, DropdownItem, Stack } from '@optimus-web/core';
import { TooltippedSpan } from '@mews-commander/ui';
import { TaxesFieldNames } from '../../formEnums';
import { TaxConfiguration } from '../../../../hooks/useConfigureProductTax';
import { FormFieldHintIcon } from './FormFieldHintIcon';
import { TaxRateSelectField } from './TaxRateSelectField';

const columnHelper = createColumnHelper<TaxConfiguration>();

export const useColumns = ({
    searchTaxRates,
    selectedTaxEnvironments,
}: {
    searchTaxRates: SelectFieldProps['customSearch'];
    selectedTaxEnvironments: string[];
}) => [
    columnHelper.accessor('legalEnvironmentName', {
        header: () => lt('ConfigureProductDropdownTaxEnv'),
        cell: (props) => props.getValue(),
        meta: {
            filtersType: ColumnFilterType.MultiSelect,
            getMultiSelectOptions: () => selectedTaxEnvironments.map((value) => ({ value, label: value })),
        },
        enableColumnFilter: true,
    }),
    columnHelper.accessor('code', {
        header: () => lt('ConfigureProductDropdownTaxType'),
        meta: {
            width: 300,
        },
        cell: (props) => {
            const code = props.getValue();
            const { localName, name } = props.row.original;

            return (
                <Stack style={{ width: '100%' }} distribution="stretch">
                    <TooltippedSpan tooltip={localName || name}>
                        <FormSelectField
                            readOnly
                            name={`${TaxesFieldNames.TaxationCode}.${code}`}
                            required
                            insideCompoundField
                        >
                            <DropdownItem label={localName || name} value={code} />
                        </FormSelectField>
                    </TooltippedSpan>
                </Stack>
            );
        },
    }),
    columnHelper.accessor('taxRates', {
        header: () => lt('ConfigureProductDropdownTaxRate'),
        meta: {
            width: 300,
        },
        cell: (props) => {
            const taxRates = props.getValue();
            const { code, environmentCode } = props.row.original;

            return (
                <Stack spacing="200" itemAlignment="center" distribution="stretch" fill>
                    <TaxRateSelectField
                        code={code}
                        environmentCode={environmentCode}
                        inline
                        searchTaxRates={searchTaxRates}
                        taxRates={taxRates}
                    />
                    <FormFieldHintIcon
                        isOptional
                        fieldName={`${TaxesFieldNames.TaxEnvironmentCode}.${environmentCode}.${TaxesFieldNames.TaxRate}.${code}`}
                    />
                </Stack>
            );
        },
    }),
];
